// Runtime configuration using environment variables
// This replaces next/config for Next.js 16 compatibility

export const publicRuntimeConfig = {
  host: process.env.VENDOR_HOST,
  newrelic: {
    enabled: process.env.NEW_RELIC_ENABLED,
    agentID: process.env.NEW_RELIC_AGENT_ID,
    applicationID: process.env.NEW_RELIC_APPLICATION_ID,
  },
  analytics: {
    enabled: process.env.ENSIGHTEN_ENABLED,
    env: process.env.ENSIGHTEN_ENV,
  },
  appEnv: process.env.APP_ENV,
  featuresRefreshInterval: process.env.FEATURES_REFRESH_INTERVAL,
  featuresAppUrl: process.env.FEATURES_APP_URL,
  featuresAppEnvironment: process.env.FEATURES_APP_ENV,
  featuresInstanceId: process.env.FEATURES_INSTANCE_ID,
  featureFlagName: 'Crayon feature flags',
  applicationName: process.env.APPLICATION_NAME || 'content-app',
  applicationVersion: process.env.APPLICATION_VERSION || 'unknown',
  applicationNamespace: 'content-app',
  analyticsUrl: `https://${process.env.VENDOR_HOST}/static/analytics/ensighten/${process.env.ENSIGHTEN_ENV}/nexus-web.js`,
  newRelicEnabled: process.env.NEW_RELIC_ENABLED,
  newRelicAgentId: process.env.NEW_RELIC_AGENT_ID,
  newRelicApplicationId: process.env.NEW_RELIC_APPLICATION_ID,
  monetateApiURL: process.env.MONETATE_API_URL,
  monetateEnvironment: process.env.MONETATE_ENVIRONMENT,
  monetateExperienceName: process.env.MONETATE_EXPERIENCE_NAME,
};

export const serverRuntimeConfig = {
  isDev: process.env.NODE_ENV === 'development',
  featuresRefreshInterval: process.env.FEATURES_REFRESH_INTERVAL,
  featuresAppUrl: process.env.FEATURES_APP_URL,
  featuresAppEnvironment: process.env.FEATURES_APP_ENV,
  featuresInstanceId: process.env.FEATURES_INSTANCE_ID,
  productCatalogueEndpoint: process.env.PRODUCT_CATALOGUE_ENDPOINT,
  productCatalogueApiKey: process.env.PRODUCT_CATALOGUE_KEY,
};

export default function getConfig() {
  return {
    publicRuntimeConfig,
    serverRuntimeConfig,
  };
}
